export const homePhonePrefixReg = /\+/;
export const homePhoneNotPrefixReg = /^0/;

// https://regex101.com/r/dkFASs/142
export const contactNumberReg = /^((\+)[0-9]{0,13}|(\d){0,13})$/;

// export const contactNumberNotLengthReg = /^((\+)[0-9]{0,}|(\d){0,})$/;
